import convertKeys from 'utils/convert-keys'
import { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'

import { TNG_SURVEYS } from 'resources/endpoints'

const fetchAll = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(`${TNG_SURVEYS}/`)

  return convertKeys.toCamel(data)
}

const fetchSurvey = async (surveyId) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(`${TNG_SURVEYS}/${surveyId}/`)

  return convertKeys.toCamel(data)
}

const submitSurvey = async (surveyId, payload) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${TNG_SURVEYS}/${surveyId}/submit/`, payload)

  return convertKeys.toCamel(data)
}

export default {
  submitSurvey,
  fetchAll,
  fetchSurvey,
}
